import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import BeforeLoginMenu from "../../routes/BeforeLoginMenu";
import AfterLoginMenu from "../../routes/AfterLoginMenu";
import axios from "axios";

class OcrCheckout extends Component {
    constructor(props) {
        super(props);
        if (process.env.NODE_ENV !== 'development') {
            document.addEventListener('contextmenu', (e) => {
                e.preventDefault();
            }
            );
            document.onkeydown = function (e) {
                if (e.keyCode == 123) {
                    return false;
                }
                if (e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
                    return false;
                }
                if (e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
                    return false;
                }
                if (e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
                    return false;
                }
                if (e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
                    return false;
                }
            }
        }
        const token = localStorage.getItem("token");
        const ocrData = sessionStorage.getItem("ocrData");

        this.ref = React.createRef()
        this.state = {
            token: token,
            items: ocrData ? JSON.parse(ocrData) : {},
            paymentType: "card",
            cardType: "",
            cardName: "",
            cardNumber: "",
            expiryDate: "",
            cvv: "",
            routingNumber: "",
            accountNumber: "",
            accountName: "",
            bankName: "",
            accountType: "",
            firstName: "",
            lastName: "",
            address: "",
            city: "",
            state: "",
            zipcode: "",
            successMessage: "",
            errorMessage: "",
            coupons: [],
            paymentInProgress: false,
            DicountedAMount: 0,
            instalTotalPrice: null,
            isCouponApplyed: false,
            isIndvSubsc: false
        };

        if (!token) {
            this.props.history.push("/login");
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);



    }

    isPaymentApproved = (paymentResponse) => {
        if (paymentResponse?.Success !== undefined) {
            return paymentResponse.Success === true &&
                String(paymentResponse.Result) === "0" &&
                String(paymentResponse.ResultMessage).toUpperCase() === "APPROVAL";
        }

        return paymentResponse?.transactionResponse?.responseCode == 1;
    };

    getPaymentMessage = (paymentResponse) =>
        paymentResponse?.ResultMessage ||
        paymentResponse?.messages?.message?.[0]?.text ||
        paymentResponse?.transactionResponse?.errors?.[0]?.errorText ||
        "Payment was not approved.";



    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
        });
    }


    refreshToken() {
        const token = localStorage.getItem("token");
        const refreshToken = localStorage.getItem("refreshToken");
        const expired = localStorage.getItem("expired");

        if (token !== null && refreshToken !== null && expired !== null) {
            axios
                .post(
                    `${process.env.REACT_APP_API_URL}api/auth/refreshToken`,
                    {
                        token: token,
                        refreshToken: refreshToken,
                        expiration: expired,
                    }
                )
                .then((response) => {
                    localStorage.removeItem("token");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("expired");
                    localStorage.setItem("token", response.data.token);
                    localStorage.setItem(
                        "refreshToken",
                        response.data.refreshToken
                    );
                    localStorage.setItem("expired", response.data.expiration);
                })
                .catch((error) => {
                    if (
                        error.response.status === 400 ||
                        error.response.status === 401 ||
                        error.response.status === 403
                    ) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("email");
                        localStorage.removeItem("userID");
                        localStorage.removeItem("userName");
                        localStorage.removeItem("secret_key");
                        localStorage.removeItem("refreshToken");
                        localStorage.removeItem("expired");
                        localStorage.removeItem("rxWholesaler");
                        this.props.history.push("/login");
                    }
                });
        }
    }



    handlePaymentChange(type) {
        this.setState({
            paymentType: type,
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ paymentInProgress: true })
        const {
            items,
            paymentType,
            cardType,
            cardName,
            cardNumber,
            expiryDate,
            cvv,
            routingNumber,
            accountNumber,
            accountName,
            bankName,
            accountType,
            firstName,
            lastName,
            address,
            city,
            state,
            zipcode,
            email,
        } = this.state;

        const data = sessionStorage.getItem("ocrData");

        if (paymentType === "card") {
            const cardArr = {


                paymentDetailscredit: {
                    cardType: cardType,
                    cardName: cardName,
                    cardNumber: cardNumber,
                    expiryDate: expiryDate,
                    cvv: cvv
                },
                billingAddresscredit: {
                    firstName: firstName,
                    lastName: lastName,
                    address: address,
                    city: city,
                    state: state,
                    zipcode: zipcode,
                    email: localStorage.getItem("email"),
                },
            };
            // console.log(cardArr["itemscredit"]);
            axios
                .post(
                    `${process.env.REACT_APP_API_URL}api/MobileApplication/OcrCardPayment`,
                    {
                        userId: localStorage.getItem("userID"),
                        unique_ID: items.unique_ID,
                        price: this.state.items.responseData.reduce((total, file) => {
                            return total + file.price;
                        }, 0),
                        paymentDetails: cardArr["paymentDetailscredit"],
                        billingAddress: cardArr["billingAddresscredit"],
                    }
                )
                .then((response) => {
                    // console.log(response.data.messages.message[0].text);
                    // console.log(response.data.responseCode);
                    // if (response.data.messages) {
                    // if (response.data.messages.message[0].text == "Successful.") {
                    if (this.isPaymentApproved(response.data)) {
                        this.setState({
                            successMessage: this.getPaymentMessage(response.data),
                            paymentInProgress: false
                        });
                        sessionStorage.removeItem("selectedState");
                        sessionStorage.removeItem("subscriptionId");
                        localStorage.removeItem("CouponPer");
                        localStorage.removeItem("SubscriptionData");
                        localStorage.removeItem("couponID");
                        localStorage.removeItem("CouponPer");
                        localStorage.removeItem("subsIdAllState");
                        localStorage.removeItem("IsInstalmentPayment");
                        localStorage.removeItem("MaintenanceCharges");
                        localStorage.removeItem("InstallmenetAmount");
                        localStorage.removeItem("subsId");
                        this.ref.current.click();
                        this.props.history.push("/?ocrpayment=success&unique_ID=" + items.unique_ID);
                    } else {
                        this.ref.current.click()
                        setTimeout(() => {
                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            });
                        }, 800);
                        this.setState({
                            errorMessage: this.getPaymentMessage(response.data),
                            successMessage: "",
                            paymentInProgress: false
                        });

                    }
                })
                .catch((error) => {
                    // console.log(error)
                    this.ref.current.click()
                    setTimeout(() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }, 800);
                    this.setState({
                        errorMessage: 'Payment failed. Verify in your profile, or retry after some time, if subscription is not active.',
                        successMessage: "",
                        paymentInProgress: false
                    });

                });

            // console.log(JSON.stringify(cardArr));
            // console.log(JSON.stringify(cardArr["billingAddresscredit"]));
        } else {
            // var data = JSON.parse(localStorage.getItem("SubscriptionData"));
            const echeckArr = {
                paymentDetails: {
                    routingNumber: routingNumber,
                    accountNumber: accountNumber,
                    accountName: accountName,
                    bankName: bankName,
                    accountType: "",
                },
                billingAddress: {
                    firstName: firstName,
                    lastName: lastName,
                    address: address,
                    city: city,
                    state: state,
                    zipcode: zipcode,
                    email: localStorage.getItem("email")
                },
            };
            console.log(echeckArr["items"],)
            axios
                .post(
                    `${process.env.REACT_APP_API_URL}api/MobileApplication/OcrEcheckPayment`,
                    {
                        headers: {
                            Authorization: `Bearer ${this.state.token}`,
                            secret_key: localStorage.getItem("secret_key"),
                        },
                        userId: localStorage.getItem("userID"),
                        unique_ID: items.unique_ID,
                        price: this.state.items.responseData.reduce((total, file) => {
                            return total + file.price;
                        }, 0),
                        paymentDetails: echeckArr["paymentDetails"],
                        billingAddress: echeckArr["billingAddress"],
                    }
                )
                .then((response) => {
                    //console.log(response.data.transactionResponse.responseCode);
                    // if (response.data.messages.message[0].text == "Successful.") {
                    if (this.isPaymentApproved(response.data)) {

                        this.setState({
                            successMessage: this.getPaymentMessage(response.data),
                            paymentInProgress: false
                        });
                        this.ref.current.click()
                        alert("Payment has been done successfully. Proceed to next step.")
                        this.props.history.push("/?ocrpayment=success&unique_ID=" + items.unique_ID);
                    } else {
                        this.ref.current.click()
                        setTimeout(() => {
                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            });
                        }, 800);
                        this.setState({
                            errorMessage: this.getPaymentMessage(response.data),
                            successMessage: "",
                            paymentInProgress: false
                        });
                        // this.props.history.push("/?ocrpayment=success&unique_ID=" + items.unique_ID);
                    }
                })
                .catch((error) => {
                    // console.log(error);
                    this.ref.current.click()
                    setTimeout(() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }, 800);

                    this.setState({
                        errorMessage: 'Payment failed. Verify in your profile, or retry after some time, if subscription is not active.',
                        successMessage: "",
                        paymentInProgress: false
                    });

                });

            // console.log(JSON.stringify(echeckArr));
        }
    }




    componentDidMount() {
        this.refreshToken();
    }


    calculateTotal() {
        let ids = JSON.parse(localStorage.getItem("subsId"));
        let SubscriptionData = JSON.parse(localStorage.getItem("SubscriptionData"));
        let allState = JSON.parse(localStorage.getItem("subsIdAllState"));
        let instAmount = [];
        let totalAmounts = 0;
        if (ids?.length && allState === null || ids?.length && allState === undefined) {
            let loop = undefined;
            for (let i = 0; i < SubscriptionData.length; i++) {
                let dIndx = SubscriptionData.findIndex(x => x.subscriptionID == ids[i]?.subid && x.filterStates == ids[i]?.state);
                console.log(dIndx)
                if (dIndx !== -1) {
                    const MaintenanceCharges = JSON.parse(localStorage.getItem("MaintenanceCharges"));
                    instAmount.push(+parseFloat(SubscriptionData[dIndx].actualPrice / 12 + MaintenanceCharges).toFixed(2));

                } else {
                    // var result = SubscriptionData.filter(function (item) {
                    //     return !ids.some(function (el) {
                    //         console.log(el)
                    //         return el.subid === item.subscriptionID && el.state === item.filterStates
                    //     })
                    // });

                    var result = SubscriptionData.filter(el => {
                        return !ids.find(element => {
                            return element.subid === el.subscriptionID && element.state === el.filterStates;
                        });
                    });

                    for (let i = 0; i < result.length; i++) {
                        if (loop !== result.length) {
                            loop = i + 1
                            instAmount.push(+parseFloat(result[i].actualPrice).toFixed(2));
                        }
                    }
                }
            }

            for (let index = 0; index < instAmount.length; index++) {
                totalAmounts += instAmount[index];
            }
            this.setState({
                instalTotalPrice: totalAmounts
            })
        } else if (ids?.length && allState !== null || ids?.length && allState !== undefined) {
            let loop = undefined;
            for (let i = 0; i < SubscriptionData.length; i++) {
                let dIndx = SubscriptionData.findIndex(x => x.subscriptionID == ids[i]?.subid && allState.state == ids[i]?.state || x.subscriptionID == ids[i]?.subid && x.filterStates == ids[i]?.state);
                console.log(dIndx)
                if (dIndx !== -1) {
                    const MaintenanceCharges = JSON.parse(localStorage.getItem("MaintenanceCharges"));
                    instAmount.push(+parseFloat(SubscriptionData[dIndx].actualPrice / 12 + MaintenanceCharges).toFixed(2));

                } else {

                    var result = SubscriptionData.filter(el => {
                        return !ids.find(element => {
                            return element.subid === el.subscriptionID && element.state === el.filterStates || element.subid === el.subscriptionID && element.state === allState.state;
                        });
                    });

                    for (let i = 0; i < result.length; i++) {
                        if (loop !== result.length) {
                            loop = i + 1
                            instAmount.push(+parseFloat(result[i].actualPrice).toFixed(2));
                        }
                    }

                }
            }

            for (let index = 0; index < instAmount.length; index++) {
                totalAmounts += instAmount[index];
            }
            this.setState({
                instalTotalPrice: totalAmounts
            })
        }
        else {
            this.setState({
                instalTotalPrice: null
            })
        }
    }



    render() {
        return (
            <>
                {this.state.token !== null ? (
                    <AfterLoginMenu />
                ) : (
                    <BeforeLoginMenu />
                )}
                <main role="main" className="">
                    <div className="pt-3 pb-5">
                        <div className="container">
                            {this.state.errorMessage !== "" && (
                                <div
                                    className="alert alert-danger alert-dismissible fade show"
                                    role="alert"
                                >
                                    {this.state.errorMessage}
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                    ></button>
                                </div>
                            )}
                            {this.state.successMessage !== "" && (
                                <div
                                    className="alert alert-success alert-dismissible fade show"
                                    role="alert"
                                >
                                    {this.state.successMessage}
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                    ></button>
                                </div>
                            )}

                            <div className="col-12 check-mobile-pad">

                                <h3 className="bold_text_no_text_transform font20">
                                    Order information
                                </h3>
                                <div className="table-responsive checkout-table">
                                    <table className="table table-bordered border-warning">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    State
                                                </th>
                                                <th scope="col">MSa</th>
                                                <th scope="col">Hospital</th>
                                                <th scope="col">Files</th>
                                                <th scope="col">Total Page</th>
                                                <th scope="col">Unit Price(USD)</th>
                                            </tr>
                                        </thead>
                                        {this.state.items && this.state.items.responseData && (
                                            <tbody>
                                                <tr>
                                                    <td>{this.state.items.state}</td>
                                                    <td>{this.state.items.msaname}</td>
                                                    <td>{this.state.items.hospitalname}</td>
                                                    <td>{this.state.items.responseData.length} Files</td>
                                                    <td align="right">
                                                        {this.state.items.responseData.reduce((total, file) => {
                                                            const pageCount = file.pageCount || 1;
                                                            return total + pageCount;
                                                        }, 0)}
                                                    </td>

                                                    <td align="right">
                                                        $0.86
                                                    </td>



                                                </tr>
                                            </tbody>
                                        )}

                                        <tbody>
                                            <tr>

                                                <td
                                                    colSpan="5"
                                                    className="text-right font-weight-bold"
                                                >
                                                    TOTAL
                                                </td>
                                                <td align="right" colSpan="1" className="font-weight-bold">
                                                    ${this.state.items.responseData.reduce((total, file) => {
                                                        return total + file.price;
                                                    }, 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                <div className="row">
                                    <aside className="col-lg-6">
                                        <h3 className="bold_text_no_text_transform font20 pl-3">
                                            Payment information
                                        </h3>
                                        <hr className="border border-warning" />
                                        <div className="card-body check-mobile-pad">
                                            <ul
                                                className="nav bg-light nav-pills rounded nav-fill mb-3"
                                                role="tablist"
                                            >
                                                <li
                                                    className="nav-item"
                                                    onClick={() => {
                                                        this.handlePaymentChange(
                                                            "card"
                                                        );
                                                    }}
                                                >
                                                    <a
                                                        className="nav-link active"
                                                        data-toggle="pill"
                                                        href="#nav-tab-card"
                                                    >
                                                        <i className="fa fa-credit-card"></i>{" "}
                                                        Credit / Debit Card
                                                    </a>
                                                </li>
                                                <li
                                                    className="nav-item"
                                                    onClick={() => {
                                                        this.handlePaymentChange(
                                                            "echeck"
                                                        );
                                                    }}
                                                >
                                                    <a
                                                        className="nav-link"
                                                        data-toggle="pill"
                                                        href="#nav-tab-bank"
                                                    >
                                                        <i className="fa fa-university"></i>{" "}
                                                        Echeck Payment
                                                    </a>
                                                </li>
                                            </ul>

                                            <div className="tab-content">
                                                <div
                                                    className="tab-pane fade show active"
                                                    id="nav-tab-card"
                                                >
                                                    <div className="form-group">
                                                        <label className="font-weight-bold">
                                                            Card Type
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <div className="input-group">
                                                            <select
                                                                className="form-control border border-warning"
                                                                name="cardType"
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                            >
                                                                <option value="">
                                                                    Select
                                                                </option>
                                                                <option value="Visa">
                                                                    Visa
                                                                </option>
                                                                <option value="Master Card">
                                                                    Master Card
                                                                </option>
                                                                <option value="Discover">
                                                                    Discover
                                                                </option>
                                                                <option value="American Express">
                                                                    American
                                                                    Express
                                                                </option>
                                                            </select>

                                                            <div className="input-group-append">
                                                                <span className="input-group-text text-muted">
                                                                    <i className="fa fa-cc-visa"></i>{" "}
                                                                    <i className="fa fa-cc-amex ml-1"></i>{" "}

                                                                    <i className="fa fa-cc-mastercard"></i>
                                                                    &nbsp;
                                                                    <i className="fa fa-cc-discover"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="font-weight-bold">
                                                            Name on the Card
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control border border-warning"
                                                            name="cardName"
                                                            placeholder=""
                                                            onChange={
                                                                this
                                                                    .handleChange
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="font-weight-bold">
                                                            Card Number
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control border border-warning"
                                                                name="cardNumber"
                                                                placeholder=""
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-sm-5">
                                                            <div className="form-group">
                                                                <label>
                                                                    <span className="hidden-xs font-weight-bold">
                                                                        Expiry
                                                                        Date
                                                                        <span className="text-danger">
                                                                            *
                                                                        </span>
                                                                    </span>{" "}
                                                                </label>
                                                                <div className="input-group">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control border border-warning "
                                                                        placeholder="MM/YYYY"
                                                                        name="expiryDate"
                                                                        onChange={
                                                                            this
                                                                                .handleChange
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <div className="form-group">
                                                                <label
                                                                    className="font-weight-bold"
                                                                    data-toggle="tooltip"
                                                                    title=""
                                                                    data-original-title="3 digits code on back side of the card"
                                                                >
                                                                    CVV
                                                                    <span className="text-danger">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control border border-warning"
                                                                    onChange={
                                                                        this
                                                                            .handleChange
                                                                    }
                                                                    name="cvv"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="tab-pane fade"
                                                    id="nav-tab-bank"
                                                >
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label font-weight-bold">
                                                            Routing Number
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <div className="col-sm-9">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="routingNumber"
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label font-weight-bold">
                                                            Account Number
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <div className="col-sm-9">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="accountNumber"
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label font-weight-bold">
                                                            Name on Bank Account
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <div className="col-sm-9">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="accountName"
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label font-weight-bold">
                                                            Bank Name
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <div className="col-sm-9">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="bankName"
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label font-weight-bold">
                                                            Account type
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <div className="col-sm-9">
                                                            <select
                                                                name="accountType"
                                                                className="form-control"
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                            >
                                                                <option value="Savings">
                                                                    Savings
                                                                </option>
                                                                <option value="Checking">
                                                                    Checking
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </aside>
                                    <aside className="col-lg-6">
                                        <h3 className="bold_text_no_text_transform font20 pl-3">
                                            Billing information
                                        </h3>
                                        <hr className="border border-warning" />

                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label font-weight-bold">
                                                First Name
                                                <span className="text-danger">
                                                    *
                                                </span>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="firstName"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label font-weight-bold">
                                                Last Name
                                                <span className="text-danger">
                                                    *
                                                </span>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="lastName"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label font-weight-bold">
                                                Address
                                                <span className="text-danger">
                                                    *
                                                </span>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="address"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label font-weight-bold">
                                                City
                                                <span className="text-danger">
                                                    *
                                                </span>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="city"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label font-weight-bold">
                                                State
                                                <span className="text-danger">
                                                    *
                                                </span>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="state"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label font-weight-bold">
                                                Zip Code
                                                <span className="text-danger">
                                                    *
                                                </span>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="zipcode"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            {
                                                this.state.paymentType === 'card' ?
                                                    <button type="submit" className="btn btn-orange mb-2 float-right"
                                                        disabled={this.state.cardType === '' || this.state.cardName === '' || this.state.cardNumber === '' || this.state.expiryDate === '' || this.state.cvv === '' || this.state.firstName === '' || this.state.lastName === '' || this.state.address === '' || this.state.city === '' || this.state.state === '' || this.state.zipcode === '' || this.state.paymentInProgress} data-toggle="modal" data-target="#payment_process_Modal">
                                                        Make Payment
                                                    </button>
                                                    :
                                                    <button type="submit" className="btn btn-orange mb-2 float-right"
                                                        disabled={this.state.routingNumber === '' || this.state.accountNumber === '' || this.state.accountName === '' || this.state.bankName === '' || this.state.firstName === '' || this.state.lastName === '' || this.state.address === '' || this.state.city === '' || this.state.state === '' || this.state.zipcode === '' || this.state.paymentInProgress} data-toggle="modal" data-target="#payment_process_Modal">
                                                        Make Payment
                                                    </button>
                                            }

                                        </div>
                                    </aside>

                                </div>
                            </form>


                            {/* payment Under process modal  */}
                            <div className="modal fade" id="payment_process_Modal" data-backdrop="static">
                                <div className="modal-dialog modal-dialog-scrollable payment_process_modal">
                                    <div className="modal-content ">

                                        <div className="modal-body ">
                                            <span data-dismiss="modal" ref={this.ref} ></span>
                                            <div className="loader"></div>
                                            <p>Your payment is under process. Please do not refresh the page or hit back button now.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}
export default withRouter(OcrCheckout);
